DS.JSONTransforms['raw'] = {
  serialize: function(value) {
    return value;
  },

  deserialize: function(value) {
    return value;
  }
};

PegasusTemplate.ApplicationSerializer = DS.JSONSerializer.extend({
});

PegasusTemplate.FixtureAdapter = DS.FixtureAdapter.extend({
  didFindAll: function(store, type, payload) {
    PegasusTemplate.lookupController('launchPlatform').didRetrieve(type);
    this._super(store, type, payload);
  }
});

PegasusTemplate.Store = DS.Store.extend({
  revision: 12,
  adapter: PegasusTemplate.FixtureAdapter.create(),
  blockForName: function(name){
    var blocks = this.all(PegasusTemplate.Block);
    return blocks.filterProperty('name', name).get('firstObject');
  }
});
